import { render, staticRenderFns } from "./DetailLahanMap.vue?vue&type=template&id=b719656c"
import script from "./DetailLahanMap.vue?vue&type=script&lang=js"
export * from "./DetailLahanMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports